/* GLAYVIA experience engine — GSAP + ScrollTrigger + Lenis (loaded on desktop only) */
(function () {
  if (window.__glbXP) return; window.__glbXP = true;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia('(pointer: fine)').matches;
  var desktop = window.matchMedia('(min-width: 901px)').matches;

  function ready(fn){ if(document.readyState !== 'loading'){ fn(); } else { document.addEventListener('DOMContentLoaded', fn); } }

  ready(function () {
    var hasGsap = typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined';
    if (hasGsap) gsap.registerPlugin(ScrollTrigger);

    /* ---------- Lenis smooth scroll (desktop, motion-ok, outside theme editor) ---------- */
    var inEditor = !!(window.Shopify && Shopify.designMode);
    if (!reduced && desktop && !inEditor && typeof Lenis !== 'undefined' && hasGsap) {
      var lenis = new Lenis({ duration: 1.15, smoothWheel: true });
      lenis.on('scroll', ScrollTrigger.update);
      gsap.ticker.add(function (t) { lenis.raf(t * 1000); });
      gsap.ticker.lagSmoothing(0);
      document.documentElement.classList.add('glb-lenis');
    }

    /* ---------- Aurora canvas in hero (desktop only — skip rAF loop on mobile) ---------- */
    var cv = document.getElementById('glb-aurora');
    if (cv && !reduced && desktop) {
      var ctx = cv.getContext('2d');
      var blobs = [
        { c: [232,215,185], r: .38, sx: .8,  sy: .18, ax: .16, ay: .10, p: 0    },
        { c: [250,234,161], r: .30, sx: .12, sy: .30, ax: .12, ay: .14, p: 2.1  },
        { c: [243,217,212], r: .34, sx: .55, sy: .82, ax: .18, ay: .09, p: 4.2  },
        { c: [214,196,160], r: .26, sx: .30, sy: .62, ax: .10, ay: .16, p: 1.3  }
      ];
      var W, H; function size(){ var r = cv.getBoundingClientRect(); W = cv.width = r.width; H = cv.height = r.height; }
      size(); addEventListener('resize', size, { passive: true });
      var mx = .5, my = .5;
      if (fine) addEventListener('mousemove', function(e){ mx = e.clientX/innerWidth; my = e.clientY/innerHeight; }, { passive:true });
      var visible = true;
      new IntersectionObserver(function(en){ visible = en[0].isIntersecting; }).observe(cv);
      (function draw(t){
        requestAnimationFrame(draw);
        if (!visible) return;
        t *= 0.00028;
        ctx.clearRect(0,0,W,H);
        ctx.globalCompositeOperation = 'lighter';
        for (var i=0;i<blobs.length;i++){
          var b = blobs[i];
          var x = (b.sx + Math.sin(t*1.3 + b.p) * b.ax + (mx-.5)*.06) * W;
          var y = (b.sy + Math.cos(t*1.1 + b.p) * b.ay + (my-.5)*.06) * H;
          var rr = b.r * Math.min(W,H) * (1 + Math.sin(t*2 + b.p)*.08);
          var g = ctx.createRadialGradient(x,y,0,x,y,rr);
          g.addColorStop(0,'rgba('+b.c[0]+','+b.c[1]+','+b.c[2]+',0.55)');
          g.addColorStop(1,'rgba('+b.c[0]+','+b.c[1]+','+b.c[2]+',0)');
          ctx.fillStyle = g; ctx.beginPath(); ctx.arc(x,y,rr,0,7); ctx.fill();
        }
      })(0);
    }

    /* ---------- Split-text headline ---------- */
    document.querySelectorAll('[data-glb-split]').forEach(function (el) {
      if (reduced || !hasGsap) return;
      var chars = [];
      el.querySelectorAll('.glb-line').forEach(function (line) {
        var text = line.textContent; line.textContent = '';
        var word = document.createElement('span'); word.className = 'glb-word'; line.appendChild(word);
        text.split('').forEach(function (ch) {
          var s = document.createElement('span'); s.className = 'glb-char';
          s.innerHTML = ch === ' ' ? '&nbsp;' : ch; word.appendChild(s); chars.push(s);
        });
      });
      gsap.to(chars, { y: 0, rotate: 0, opacity: 1, duration: 1.1, ease: 'power4.out', stagger: 0.028, delay: 0.15 });
    });

    /* ---------- Generic reveals ---------- */
    if (hasGsap && !reduced) {
      document.querySelectorAll('.glb-reveal').forEach(function (el, i) {
        ScrollTrigger.create({ trigger: el, start: 'top 88%', once: true,
          onEnter: function(){ setTimeout(function(){ el.classList.add('is-in'); }, (parseInt(el.dataset.delay||0,10)) ); } });
      });
    } else { document.querySelectorAll('.glb-reveal').forEach(function(el){ el.classList.add('is-in'); }); }

    /* ---------- Hero parallax stage (collage) ---------- */
    var stage = document.querySelector('.glb-hero__stage');
    if (stage && hasGsap && !reduced) {
      var cards = stage.querySelectorAll('.glb-card[data-glb-float]');
      var chips = stage.querySelectorAll('.glb-chip[data-glb-float]');
      var floaters = stage.querySelectorAll('[data-glb-float]');
      gsap.from(floaters, { yPercent: 14, autoAlpha: 0, duration: 1.3, ease: 'power4.out', stagger: 0.1, delay: 0.3 });
      if (fine) stage.closest('.glb-hero').addEventListener('mousemove', function (e) {
        var r = this.getBoundingClientRect();
        var dx = (e.clientX - r.left) / r.width - .5, dy = (e.clientY - r.top) / r.height - .5;
        cards.forEach(function (el) {
          var f = parseFloat(el.getAttribute('data-glb-float')) || 0.5;
          gsap.to(el, { x: dx * -24 * f, y: dy * -18 * f, duration: 1, ease: 'power3.out', overwrite: 'auto' });
        });
        chips.forEach(function (el) {
          var f = parseFloat(el.getAttribute('data-glb-float')) || 0.5;
          gsap.to(el, { x: dx * -30 * f, duration: 1, ease: 'power3.out', overwrite: 'auto' });
        });
      }, { passive: true });
      chips.forEach(function (chip, i) {
        gsap.to(chip, { y: '+=8', duration: 2.4 + i * 0.4, ease: 'sine.inOut', repeat: -1, yoyo: true, delay: 0.6 + i * 0.3 });
      });
      gsap.to(stage, { yPercent: -6, ease: 'none', scrollTrigger: { trigger: '.glb-hero', start: 'top top', end: 'bottom top', scrub: true } });
    }

    /* ---------- Magnetic buttons ---------- */
    if (hasGsap && !reduced && fine) {
      document.querySelectorAll('.glb-magnetic').forEach(function (btn) {
        btn.addEventListener('mousemove', function (e) {
          var r = btn.getBoundingClientRect();
          gsap.to(btn, { x: (e.clientX - r.left - r.width/2) * .32, y: (e.clientY - r.top - r.height/2) * .32, duration: .5, ease: 'power3.out' });
        });
        btn.addEventListener('mouseleave', function () { gsap.to(btn, { x: 0, y: 0, duration: .7, ease: 'elastic.out(1,.45)' }); });
      });
    }

    /* ---------- Counters ---------- */
    document.querySelectorAll('[data-glb-count]').forEach(function (el) {
      var end = parseFloat(el.dataset.glbCount), dec = parseInt(el.dataset.glbDec || 0, 10), suf = el.dataset.glbSuffix || '';
      function set(v){ el.firstChild.nodeValue = v.toFixed(dec).replace(/\B(?=(\d{3})+(?!\d))/g, ',') + suf; }
      if (!hasGsap || reduced) { set(end); return; }
      var o = { v: 0 }; set(0);
      ScrollTrigger.create({ trigger: el, start: 'top 88%', once: true, onEnter: function () {
        gsap.to(o, { v: end, duration: 1.8, ease: 'power3.out', onUpdate: function(){ set(o.v); } });
      }});
    });

    /* ---------- Shade gallery: pinned horizontal on desktop ---------- */
    var track = document.querySelector('.glb-shades__track');
    if (track && hasGsap && !reduced && desktop) {
      var pin = document.querySelector('.glb-shades__pin');
      var getDist = function(){ return Math.max(0, track.scrollWidth - document.documentElement.clientWidth + 48); };
      var tween = gsap.to(track, { x: function(){ return -getDist(); }, ease: 'none',
        scrollTrigger: { trigger: pin, start: 'top top', end: function(){ return '+=' + (getDist() + innerHeight*0.35); },
          pin: true, scrub: 0.6, invalidateOnRefresh: true, anticipatePin: 1,
          onUpdate: function (self) { var bar = document.querySelector('.glb-shades__progress i'); if (bar) bar.style.transform = 'scaleX(' + self.progress + ')'; } } });
      track.querySelectorAll('.glb-shade').forEach(function (card) {
        gsap.from(card, { y: 60, opacity: 0, duration: .9, ease: 'power3.out',
          scrollTrigger: { trigger: card, containerAnimation: tween, start: 'left 95%', once: true } });
      });
    } else if (track) {
      var bar2 = document.querySelector('.glb-shades__progress i');
      var scroller = track;
      scroller.addEventListener('scroll', function(){
        var max = scroller.scrollWidth - scroller.clientWidth;
        if (bar2 && max > 0) bar2.style.transform = 'scaleX(' + (scroller.scrollLeft / max) + ')';
      }, { passive: true });
    }

    /* ---------- 3D tilt on shade / kit cards (desktop) ---------- */
    if (fine && !reduced && hasGsap) {
      document.querySelectorAll('.glb-shade:not(.glb-shade--cta), .glb-kitcard').forEach(function (card) {
        card.addEventListener('mousemove', function (e) {
          var r = card.getBoundingClientRect();
          var dx = (e.clientX - r.left) / r.width - .5, dy = (e.clientY - r.top) / r.height - .5;
          gsap.to(card, { rotateY: dx * 8, rotateX: dy * -8, transformPerspective: 900, duration: .5, ease: 'power2.out' });
        });
        card.addEventListener('mouseleave', function () { gsap.to(card, { rotateX: 0, rotateY: 0, duration: .8, ease: 'power3.out' }); });
      });
    }

    /* ---------- Ritual: progress line + step activation ---------- */
    var ritual = document.querySelector('.glb-ritual');
    if (ritual) {
      var line = ritual.querySelector('.glb-ritual__line i');
      var steps = ritual.querySelectorAll('.glb-rstep');
      if (hasGsap && !reduced && line) {
        gsap.to(line, { scaleY: 1, ease: 'none', scrollTrigger: { trigger: ritual.querySelector('.glb-ritual__grid'), start: 'top 70%', end: 'bottom 55%', scrub: true } });
      } else if (line) { line.style.transform = 'scaleY(1)'; }
      steps.forEach(function (st) {
        if (hasGsap && !reduced) {
          ScrollTrigger.create({ trigger: st, start: 'top 72%', once: true, onEnter: function(){ st.classList.add('is-on'); } });
        } else { st.classList.add('is-on'); }
      });
    }


    /* ---------- Facial: lazy MP4 slices + progress + reveals (runs on all devices) ---------- */
    (function () {
      var SPEED = 0.5, BUF = 0.12;
      function playSafe(v){ if(!v) return; v.playbackRate = SPEED; var p = v.play(); if (p && p.catch) p.catch(function(){}); }
      function setup(box){
        var v = box.querySelector('video'); if (!v) return;
        if (box.dataset.ready === '1'){ playSafe(v); return; }
        var src = box.getAttribute('data-src'); if (!src) return;
        box.dataset.ready = '1';
        var s = parseFloat(box.getAttribute('data-start') || '0');
        var eRaw = box.getAttribute('data-end');
        var srcEl = document.createElement('source'); srcEl.src = src; srcEl.type = 'video/mp4'; v.appendChild(srcEl);
        v.muted = true; v.playsInline = true; v.preload = 'metadata'; v.loop = false;
        v.setAttribute('playsinline',''); v.setAttribute('muted','');
        var ready = false, lastSeek = 0;
        function endT(){ return (eRaw === 'END' || eRaw === '__END__') ? v.duration : parseFloat(eRaw || '0'); }
        function restart(){ try { v.currentTime = s; } catch(e){} playSafe(v); }
        v.addEventListener('loadedmetadata', function(){ ready = true; try { v.currentTime = s; } catch(e){} playSafe(v); }, { once: true });
        v.addEventListener('timeupdate', function(){
          if (!ready) return; var e = endT(); if (!isFinite(e)) return;
          if (v.currentTime >= e - BUF){ var now = Date.now(); if (now - lastSeek < 250) return; lastSeek = now; restart(); }
        });
        v.addEventListener('ended', function(){ if (ready) restart(); });
        box.addEventListener('click', function(){ playSafe(v); });
      }
      var slices = document.querySelectorAll('.glb-vslice');
      if (!slices.length) return;
      if (!('IntersectionObserver' in window)){ slices.forEach(setup); return; }
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(en){
          var v = en.target.querySelector('video');
          if (en.isIntersecting){ setup(en.target); if (v) playSafe(v); }
          else if (v) v.pause();
        });
      }, { rootMargin: '280px 0px', threshold: 0.2 });
      slices.forEach(function(el){ io.observe(el); });

      var grid = document.querySelector('.glb-facial__grid');
      if (grid && hasGsap && !reduced) {
        gsap.from(grid.querySelectorAll('.glb-fstep'), { y: 54, opacity: 0, duration: .9, ease: 'power3.out', stagger: .1,
          scrollTrigger: { trigger: grid, start: 'top 82%', once: true } });
        var fbar = document.querySelector('.glb-facial__progress i');
        if (fbar) gsap.to(fbar, { scaleX: 1, ease: 'none',
          scrollTrigger: { trigger: '.glb-facial', start: 'top 75%', end: 'bottom 60%', scrub: true } });
        if (window.matchMedia('(max-width:1080px)').matches && fbar) {
          grid.addEventListener('scroll', function(){
            var max = grid.scrollWidth - grid.clientWidth;
            if (max > 0) fbar.style.transform = 'scaleX(' + (grid.scrollLeft / max) + ')';
          }, { passive: true });
        }
      }
    })();

    if (hasGsap) setTimeout(function(){ ScrollTrigger.refresh(); }, 400);
  });
})();
